var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dd8c4ffdf422ec2c1980c964b8fd340a5641fa02"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["good-neighbour-jk@good-neighbour-jk"]={id:"dd8c4ffdf422ec2c1980c964b8fd340a5641fa02"};
      